export const APP_VERSION = __APP_VERSION__
export const COMMIT_SHA = __COMMIT_SHA__
export const DISPLAY_VERSION = `${APP_VERSION}+${COMMIT_SHA}`
